import * as React from "react";
import { IButtonEvents } from "../_common/buttonEvents";
import { Icon } from "../IconSVG";
import { Wrapper } from "./components/Wrapper";

export interface IStartButton extends IButtonEvents {}

export const StartButton = (props: IStartButton) => (
  <Wrapper {...props}>
    <Icon type="play" />
  </Wrapper>
);
